module.exports = __webpack_public_path__ + "static/media/story-11.2fe7ce20.jpg";